export default "__VITE_ASSET__07ad15ce__"